<template>
  <div>
    <keep-alive>
  <editor-chat v-if="uiStore.viewCode === 1"></editor-chat>
  <editor-friend v-if="uiStore.viewCode === 2"></editor-friend>
  <editor-group v-if="uiStore.viewCode === 3"></editor-group>
</keep-alive>
  </div>
</template>
<script>
import EditorChat from "./EditorChat.vue";
import EditorFriend from "./EditorFriend.vue";
import EditorGroup from "./EditorGroup.vue";

export default {
  name: "ShadanChat",
  components: {
    EditorChat,
    EditorFriend,
    EditorGroup,
  },
  props: {
    chatData: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      searchText: "",
      messageContent: "",
      group: {},
      groupMembers: [],
    };
  },
  methods: {
    onTop(chatIdx) {
      this.$store.commit("moveTop", chatIdx);
    },
    // 激活聊天数据
    activateChatData() {
      if (this.chatData) {
        console.log('[ShadanChat] 激活聊天数据:', this.chatData);
        
        // 确保聊天会话已打开
        this.$store.commit("openChat", {
          type: this.chatData.type,
          targetId: this.chatData.targetId,
          showName: this.chatData.showName,
          headImage: this.chatData.headImage,
        });
        
        // 激活第一个聊天会话（刚打开的）
        this.$store.commit("activeChat", 0);
      }
    },
  },
  computed: {
		uiStore() {
			return this.$store.state.uiStore;
		},
    chatStore() {
      return this.$store.state.chatStore;
    },
    loading() {
      return this.chatStore.loadingGroupMsg || this.chatStore.loadingPrivateMsg;
    },
  },
  watch: {
    // 监听 chatData 变化
    chatData: {
      handler(newChatData) {
        if (newChatData) {
          this.activateChatData();
        }
      },
      immediate: true
    }
  },
  mounted() {
    // 组件挂载时如果有 chatData，立即激活
    if (this.chatData) {
      this.activateChatData();
    }
  }
};
</script>

<style lang="scss">
.chat-page {
  .chat-list-box {
    display: flex;
    flex-direction: column;
    background: var(--im-background);

    .chat-list-header {
      height: 50px;
      display: flex;
      align-items: center;
      padding: 0 8px;
    }

    .chat-list-loading {
      height: 50px;
      background-color: #eee;

      .el-icon-loading {
        font-size: 24px;
        color: var(--im-text-color-light);
      }

      .el-loading-text {
        color: var(--im-text-color-light);
      }

      .chat-loading-box {
        height: 100%;
      }
    }

    .chat-list-items {
      flex: 1;
    }
  }
}
</style>
